import { Actions } from './action';

/**
 * Factory function to create instance of Actions
 * @param Type Action class to create
 */
export const ActionFactory = <T extends { id: string }>(type: string) => new Actions<T>(type);
